import * as React from "react";

function SvgPlatesWaitingToBeImaged(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.423 0h7.153c.522 0 .942.409.942.917v1.575h5.263c1.23 0 2.219.964 2.219 2.162v12.184c0 .868-.52 1.613-1.273 1.958a6.002 6.002 0 00-4.248-7.612 6.247 6.247 0 00-1.887-4.912A6.582 6.582 0 0012 4.418a6.582 6.582 0 00-4.592 1.854 6.247 6.247 0 00-1.902 4.474c0 1.678.684 3.288 1.902 4.475A6.556 6.556 0 0011 16.999V17c0 .701.12 1.374.341 2H2.22C.989 19 0 18.036 0 16.838V4.654c0-1.198.99-2.162 2.219-2.162h5.263V.917c0-.508.42-.917.941-.917zm8.653 11H17a6.002 6.002 0 00-5.843 4.63 5.13 5.13 0 01-2.75-1.382 4.89 4.89 0 01-1.49-3.502c0-1.313.536-2.573 1.49-3.502A5.15 5.15 0 0112 5.794a5.15 5.15 0 013.594 1.45 4.889 4.889 0 011.482 3.757z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 24a7 7 0 100-14 7 7 0 000 14zm0-1a6 6 0 100-12 6 6 0 000 12z"
        fill="#fff"
      />
      <path
        d="M19.625 13h-5.25a.375.375 0 00-.375.375v.25c0 .207.168.375.375.375 0 1.421.797 2.62 1.888 3-1.09.38-1.888 1.579-1.888 3a.375.375 0 00-.375.375v.25c0 .207.168.375.375.375h5.25a.375.375 0 00.375-.375v-.25a.375.375 0 00-.375-.375c0-1.421-.797-2.62-1.888-3 1.09-.38 1.888-1.579 1.888-3a.375.375 0 00.375-.375v-.25a.375.375 0 00-.375-.375zm-1.173 6h-2.904c.267-.731.814-1.25 1.452-1.25s1.185.519 1.452 1.25zm0-4h-2.904a2.931 2.931 0 01-.173-1h3.25c0 .356-.062.697-.173 1z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgPlatesWaitingToBeImaged;
